var lx = lx || {};
lx.feed = lx.feed || {};

lx.feed.cnt = 1;
lx.feed.rows = 3;
lx.feed.canLoad = true;
// filter notifications
lx.feed.filter = function (pClear) {
    if (pClear) $("input[name='P69_ENTITY']").prop('checked', false);
    lxLoad();
	apex.item("APP_FILTER").setValue(getCheckedValuesByName("P69_ENTITY"));
    apex.submit({
        request: "GO",
        set: {
            "P1_FILTER": getCheckedValuesByName("P69_ENTITY")
        }
    });
	apex.navigation.dialog.close(true);
};
// load more notifications 
lx.feed.more = function () {
    //$(".notify-IR").append('<div id="uiLoadingImg" style="clear:both;text-align:center;padding:10px;background-color:#EFEFEF;"><img src="/i/social/img/jqry/ajax-loader.gif" /></div>');
    
    lx.load.add();
    apex.server.process( "NOTIFY_MORE", {x01: lx.feed.cnt}, {dataType: "html"})
        .then( function (d) {
            lx.load.remove();
            //$("#uiLoadingImg").remove();
            //console.log(d);
            var result = $.trim(d);
            //console.log(result);
            if (result == 'NOK') {
                $(".notify-IR > #uiNoMore").remove();
                $(".notify-IR").append('<div id="uiNoMore">No more notifications to display </div>');
            } else {
                $(".notify-IR").append(d);
                lx.feed.cnt += lx.feed.rows;
                lx.feed.canLoad = true;
            }
            // comment initialization
            lx.comment.initAll();
            })
        .catch( function( jqXHR ) {
            lx.load.remove();
            console.log('more Err');
            console.log(jqXHR);
        });
};
// Initial show of the feed
lx.feed.show = function (pType, pRowCnt) {
    $(window).unbind("scroll");
    $('#lx-feed-activities').hide();

    $('#lx-feed-' + pType).show();

    if (pType == 'activities') {
        lx.feed.rows = pRowCnt;
        lx.feed.more();
        lx.feed.canLoad = false;

        //if ($(".notify-IR > .feed-post").length == 0) $(".lxFeedFilter").hide();

        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() > $(document).height() - 1200 && lx.feed.canLoad) {
                lx.feed.canLoad = false;
                lx.feed.more();
            }
        });
    }
};
// mark notification as read
lx.feed.markRead = function () {
    apex.server.process( "markNotifyRead", {}, {
        dataType: "text",
        sucess: function (d) {
            if (result == 'NOK') {
                alert('Something went wrong!')
            } else {
                lx.topMenu.reduceBadge('N');
				//$(".lxTop_N .t-Button-badge").hide();
            }
        },
        error: function( jqXHR, textStatus, errorThrown ) {
            console.log('more Err');
            console.log(jqXHR);
        }
    } );
}
// fetch extended notification
lx.feed.postExtend = function (pId, pType, pThis) {
    lx.load.add();
    apex.server.process( "notifyPostExtend", {x01: pId, x02: pType}, {dataType: "html"})
        .then( function (d) {
            lx.load.remove();
            $(pThis).closest("tr").replaceWith(d);
        }).catch( function (err) {
            lx.load.remove();
            lx.info.alert(err);
        })
}
// Refresh Task notification 
lx.feed.refreshTask = function (pTaskId) {
    lx.feed.notifyRefresh($("#lxFeedTaskClose_" + pTaskId), 32/*TASK*/, pTaskId);
    /*apex.server.process('getLastNotifyFromObject', {
        x01: 32,
        x02: pTaskId
    }, {
        dataType: "html",
        success: function(d) {
            lx.load.remove();
            $("#lxFeedTaskClose_" + pTaskId).closest(".feed-post").replaceWith(d);
            lx.comment.initAll();
        }
    });*/
};
// Close task
lx.feed.taskClose = function (pId, pThis) {
    //var conf = confirm("Are you sure you want to close this task?");//apex.lang.getMessage("CLOSE_TASK"));
    //if (conf) {
        lx.load.add();
        $(pThis).closest(".feed-actions").find(".feed-btn").toggle();
        $(pThis).closest(".feed-actions").append("Processing Response");//apex.lang.getMessage("JS36"));
        apex.server.process('CLOSE_TASK', {
            x01: pId
        }, {
            dataType: "html",
            success: function(d) {
                lx.load.remove();
                lx.feed.refreshTask(pId);
            }
        });
    //}
};
// Refresh notification with most recent
lx.feed.notifyRefresh = function (pThis, pEty, pId, pAka) {
    var vRoadmap = $(pThis).closest(".feed-actions").closest(".feed-post").hasClass("rm_feed");
    lx.load.add();
    apex.server.process("getLastNotifyFromObject", {x01: pEty, 
                                                    x02: pId, 
                                                    x03: (pAka ? pAka : ""), 
                                                    x04: (vRoadmap ? 'Y' : 'N')
                                                },{dataType: 'html'})
                .then( function (d) { 
                    lx.load.remove();
                    $(pThis).closest(".feed-post").replaceWith(d);
                    lx.comment.initAll();
                } );
}

lx.feed.getArticleAgenda = function(pId, pThis) {
    var $container = $(pThis).siblings(".feed-agenda_table");
    var vStart = 0;
    var vVisible = false;
    if ($container.is(":visible")) vVisible = true;
    var vFetch = $container.find(".feed-agenda_row").length == 0;
    if (vFetch) {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=getArticleAgenda",
                x01: pId
            },
            success: function (d) {
				console.log(d);
                $(pThis).addClass("opened")
                $container.replaceWith(d);

            }
        });
    } else if (!vVisible) {
        $container.show();
        $(pThis).addClass("opened")
    } else {
        //$(pThis).html('AGENDA');
        $(pThis).removeClass("opened")
        $container.hide();
    }
};

lx.feed.toggleTabs = function(pTab) {
    if (pTab=="filter") {
		$("#feedTabs").parent().toggleClass("lxFeedFilterH").addClass("lxFeedPostsH");
		$("#SR_feedFilter_tab").toggleClass("a-Tabs-selected").toggleClass("is-active");
		$("#SR_feedPosts_tab").removeClass("a-Tabs-selected").removeClass("is-active");
	}
    else if (pTab=="posts") {
		$("#feedTabs").parent().toggleClass("lxFeedPostsH").addClass("lxFeedFilterH");
		$("#SR_feedPosts_tab").toggleClass("a-Tabs-selected").toggleClass("is-active");
		$("#SR_feedFilter_tab").removeClass("a-Tabs-selected").removeClass("is-active");
	}
};

function lxFeedShowAll(pType, pLink) {
    if ($v("pFlowStepId") == 1) {
        lxSwitchFeed(pType);
    } else {
        redirect(pLink);
    }
};
// Create article 
lx.feed.createArticle = function (pArticle) {
	if ($v("P66_TITLE").length==0 || $v("P66_DESCRIPTION").length==0 || (pArticle=='job' && $("#P66_INDUSTRY_TYPE").select2('val').length==0) || (pArticle=='tender' && $("#P66_TENDER_CATEGORY").select2('val').length==0) || (pArticle=='tender' && $("#P66_TENDER_TYPE").select2('val').length==0) || (pArticle=='event' && $("#P66_EVENT_TYPE").select2('val').length==0)) {
		alert('All fields must be entered!');
	}
	else {
		var vPage,vItems,vValues,vRecId,vRecId2='';
		var vEty;
		if (pArticle=='update') {
            if ($v('P66_PROFILE_TYPE') == 'FOL'){
                vPage = 283;
                vEty = 1;
                vItems = 'P283_ID,P283_ETY_TYPE';
                vValues = ',NEWS'
            } else {
                vPage = 9;
                vEty = 1;
                vItems = 'P9_ID,P9_CURRENT_PAGE';
                vValues = ',21'
            }
		}
		else if (pArticle=='job') {
			vPage = 16;
			vEty = 3;
			vItems = 'P16_ID,P16_RETURN_PG';
			vValues = ',22';
			vRecId = $("#P66_INDUSTRY_TYPE").select2('val');
		}
		else if (pArticle=='event') {
			vPage = 18;
			vEty = 2;
			vItems = 'P18_ID,P18_RETURN_PG,P18_TIME_HRS_FROM_FR,P18_TIME_MIN_FROM_FR';
			vValues = ',23,24,0';
			vRecId = $("#P66_EVENT_TYPE").select2('val');
		}
		else if (pArticle=='tender') {
			vPage = 24;
			vEty = 4;
			vItems = 'P24_ID,P24_RETURN_PG';
			vValues = ',25';
			vRecId = $("#P66_TENDER_CATEGORY").select2('val');
			vRecId2 = $("#P66_TENDER_TYPE").select2('val');
		}
		
		apex.server.process('createArticle', {
			x01: vEty,
			x02: $v("P66_TITLE"),
			x03: $v("P66_DESCRIPTION"),
			x04: vRecId,
			x05: vRecId2
		}, {
			dataType: "html",
			success: function(pId) {
				//console.log(pId);
				//console.log(pId.trim());
				apex.server.process('pageLink', {
					x01: vPage,
					x02: vItems,
					x03: pId.trim() + vValues
				}, {
					dataType: "html",
					success: function(pUrl) {
                        //console.log(pUrl);
						//alert(pUrl);
						apex.navigation.redirect(pUrl);
					}
				});
			}
		});
	}
};

// Article button actions
lx.feed.articleBtnAction = function (pActionType) {
	if (pActionType=='tender') {
		$("#feedPostBtn").css("display", "none");
		$("#feedPostBtn2").css("display", "");
		$("#postTenderCat").css("display", "");
		$("#postTenderType").css("display", "");
		$("#feedPostJobContinue").css("display", "none");
		$("#feedPostEventContinue").css("display", "none");
		$("#feedPostTenderContinue").css("display", "");
	}
	else if (pActionType=='event') {
		$("#feedPostBtn").css("display", "none");
		$("#feedPostBtn2").css("display", "");
		$("#postEventType").css("display", "");
		$("#feedPostJobContinue").css("display", "none");
		$("#feedPostTenderContinue").css("display", "none");
		$("#feedPostEventContinue").css("display", "");
	}
	else if (pActionType=='job') {
		$("#feedPostBtn").css("display", "none");
		$("#feedPostBtn2").css("display", "");
		$("#postJobAdInd").css("display", "");
		$("#feedPostTenderContinue").css("display", "none");
		$("#feedPostEventContinue").css("display", "none");
		$("#feedPostJobContinue").css("display", "");
	}
	else if (pActionType=='cancel') {
		$("#feedPostBtn").css("display", "");
		$("#feedPostBtn2").css("display", "none");
		$("#postTenderType").css("display", "none");
		$("#postTenderCat").css("display", "none");
		$("#postJobAdInd").css("display", "none");
		$("#postEventType").css("display", "none");
	}
};

var lxProfileFeedCnt = 1;
var lxProfileFeedPageCnt;
var lxProfileFeedFetch = true;

function getProfileFeed(pProfileId, pRows) {
    var $container = $("#uiBillboadContent");
    var vVisible = false;
    if (pRows) lxProfileFeedPageCnt = pRows;

    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getProfileFeed",
            x01: pProfileId,
            x02: lxProfileFeedCnt
        },
        success: function (d) {
            if (lxProfileFeedCnt == 1) {
                $container.html(d);
                lxProfileFeedCnt += lxProfileFeedPageCnt;

                if ($(".notify-IR > .feed-post").length == 0) $(".lxFeedFilter").hide();

                $(window).scroll(function () {
                    if ($(window).scrollTop() + $(window).height() > $(document).height() - 1200 && lxProfileFeedFetch) {
                        lxProfileFeedFetch = false;
                        getProfileFeed(pProfileId);
                    }
                });
            } else {
                $container.find('.notify-IR').append(d);
                lxProfileFeedCnt += lxProfileFeedPageCnt;
                lxProfileFeedFetch = true;
            }
            if ($container.find(".feed-no_more").length > 0) lxProfileFeedFetch = false;
        }
    });
};